export const spacing = {
  xSmallSpacing: '0.3125rem',
  smallSpacing: '0.625rem',
  mediumSpacing: '0.9375rem',
  largeSpacing: '1.875rem',
  xLargeSpacing: '3.75rem',
} as const;
